var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPassed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2048_8270",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 64,
    height: 64
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2048_8270)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M56.7755 23.8103C56.1758 23.6126 55.776 23.6126 55.3762 23.6126C55.5761 23.6126 55.1762 23.6126 55.3762 23.6126H40.583L40.583 12.5455C40.583 9.97628 38.5839 8 35.9852 8L29.9879 8C29.1883 8 28.7885 8.19763 28.1888 8.39526C27.3891 8.59289 26.7894 9.18577 26.1897 9.77866L15.7945 23.0198H8.59787C5.99907 23.2174 4 25.1937 4 27.7628L4 53.4545C4 56.0237 5.99907 58 8.59787 58L47.18 58C48.1795 58 49.179 57.6047 49.9787 57.0119C50.7783 56.419 51.1781 55.6285 51.378 54.8379L59.7741 29.5415C60.5737 26.9723 59.1744 24.4032 56.7755 23.8103ZM12.1962 49.1067V32.1107H15.7945V49.1067H12.1962ZM24.1906 49.1067L24.1906 27.3676L31.5872 17.8814V28.1581C31.5872 30.7273 33.5863 32.7036 36.1851 32.7036H49.179L43.7815 49.1067H24.1906Z",
    fill: "#65AA20"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPassed);
export default __webpack_public_path__ + "static/media/passed.c6624d981b09617131d69cd090d91f23.svg";
export { ForwardRef as ReactComponent };